import { getFileFromNwCDN } from '~/utils/nw-cdn'

export type Partner = {
  name: string
  imageUrl: string
  credential?: string
  experienceEducation: string
  professionalImageUrl: string
  calendlyUrl?: string
}

export const getPartnerSlug = (name: string): string => name.replace(/\s/g, '-').toLowerCase()

/** Figma L→R order for New Advisor Cards (NWWP). */
export const PARTNERS: Partner[] = [
  {
    name: 'James Bashall',
    credential: 'CFP®, CPA',
    imageUrl: getFileFromNwCDN('james-bashall-card-20261002.webp'),
    experienceEducation:
      'James is a founding member of NerdWallet Wealth Partners and a Certified Financial Planner® and Certified Public Accountant with more than 10 years in financial services, including six years in wealth management. He holds a Master of Commerce in Finance from the University of Cape Town and a Master of Science in Psychology from the University of East London.',
    professionalImageUrl: getFileFromNwCDN('james-bashall-bio-20261001.webp'),
  },
  {
    name: 'Ryan Sterling',
    credential: 'CFA®',
    imageUrl: getFileFromNwCDN('ryan-sterling-card-20261002.webp'),
    experienceEducation:
      'Ryan is the founder and CEO of NerdWallet Wealth Partners and a Chartered Financial Analyst® with more than 20 years of experience in wealth management at leading firms including Capital Group Private Client Service, Goldman Sachs, and Bernstein Global Wealth Management. He holds an MBA in Investment Management from Vanderbilt University.',
    professionalImageUrl: getFileFromNwCDN('ryan-sterling-bio-20261001.webp'),
  },
  {
    name: 'William Toczylowski',
    credential: 'CFP®',
    imageUrl: getFileFromNwCDN('william-toczylowski-card-20261002.webp'),
    experienceEducation:
      'William is one of the founding members of NerdWallet Wealth Partners and a Certified Financial Planner®. He brings more than 11 years of wealth management experience. Prior to NerdWallet Wealth Partners, he worked at Capital Group, BNY Mellon Wealth Management, and Fidelity Institutional Asset Management. He holds a BS in Finance and Economics from Providence College and a Certificate in Financial Planning from New York University.',
    professionalImageUrl: getFileFromNwCDN('william-toczylowski-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/wtoczylowski-nerdwalletwealthpartners/30min',
  },
  {
    name: 'Tracey Rinaldi',
    credential: 'J.D.',
    imageUrl: getFileFromNwCDN('tracey-rinaldi-card-20261002.webp'),
    experienceEducation:
      "Tracey has 18 years of experience in the financial industry, including eight years in wealth management. Before joining NerdWallet Wealth Partners, she worked at Capital Group and holds a J.D. from the University at Buffalo Law School. She's passionate about helping women-led households and non-traditional families build financial plans that reflect their actual lives.",
    professionalImageUrl: getFileFromNwCDN('tracey-rinaldi-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/trinaldi-nerdwalletwealthpartners/30min',
  },
  {
    name: 'Michael Fishman',
    credential: 'CPA',
    imageUrl: getFileFromNwCDN('michael-fishman-card-20261002.webp'),
    experienceEducation:
      "Michael is a Certified Public Accountant with 10 years of experience in wealth management. He previously spent nine years at Goldman Sachs, solving complex client situations for Ultra-High-Net-Worth and High-Net-Worth clients. He holds a Master's in Personal Financial Planning from Bentley University.",
    professionalImageUrl: getFileFromNwCDN('michael-fishman-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/mfishman-nerdwalletwealthpartners/30min',
  },
  {
    name: 'Peter McGinley',
    credential: 'CFP®',
    imageUrl: getFileFromNwCDN('peter-mcginley-card-20261002.webp'),
    experienceEducation:
      'Peter is a Certified Financial Planner® who has spent 10 years in wealth management. He previously worked at BNY before joining NerdWallet Wealth Partners. He holds a B.S. in Finance from Providence College and a Certificate in Financial Planning from New York University.',
    professionalImageUrl: getFileFromNwCDN('peter-mcginley-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/pmcginley-nerdwalletwealthpartners/30min',
  },
  {
    name: 'Josh Rubin',
    credential: 'CFP®',
    imageUrl: getFileFromNwCDN('josh-rubin-card-20261002.webp'),
    experienceEducation:
      'Josh is a Certified Financial Planner® with more than 6 years of experience in wealth management. He previously worked at UBS and NewEdge Wealth before joining NerdWallet Wealth Partners, and is a graduate of Syracuse University holding a B.S. in Finance and Advertising.',
    professionalImageUrl: getFileFromNwCDN('josh-rubin-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/jrubin-nerdwalletwealthpartners/30min',
  },
  {
    name: 'Nick Churkovich',
    credential: 'CA',
    imageUrl: getFileFromNwCDN('nick-churkovich-card-20261002.webp'),
    experienceEducation:
      'Nick is a Chartered Accountant (the UK and international equivalent of a CPA) with more than eight years of experience in wealth management and three years in accounting. He previously worked as a Senior Associate at Koda Capital and an Analyst at Deloitte. He studied at Monash University in Melbourne.',
    professionalImageUrl: getFileFromNwCDN('nick-churkovich-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/nchurkovich-nerdwalletwealthpartners/30min',
  },
  {
    name: 'Scott Brazina',
    imageUrl: getFileFromNwCDN('scott-brazina-card-20261002.webp'),
    experienceEducation:
      'Scott is a Level II Candidate in the Chartered Financial Analyst program. Prior to NerdWallet Wealth Partners, he worked at Capital Group managing over $3 billion in client assets. He also served as head of events at Tough Mudder, an endurance event featuring obstacle courses, where he oversaw the financial performance and delivery of over 60 events nationwide. He holds a B.A. in Economics from Trinity College.',
    professionalImageUrl: getFileFromNwCDN('scott-brazina-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/sbrazina-nerdwalletwealthpartners/30min',
  },
  {
    name: 'Mike Letzter',
    imageUrl: getFileFromNwCDN('mike-letzter-card-20261002.webp'),
    experienceEducation:
      'Mike has more than 8 years of experience in wealth management, including time at Rockefeller Capital Management, where he supported the management of over $2 billion in assets for ultra-high-net-worth clients and private foundations, and at Bernstein, a private wealth firm that managed over $3 billion in client assets. He holds a B.S. in Economics and Personal Finance from the University of Wisconsin-Madison.',
    professionalImageUrl: getFileFromNwCDN('mike-letzter-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/mletzter-nerdwalletwealthpartners/30min',
  },
  {
    name: 'McClain Culver',
    imageUrl: getFileFromNwCDN('mcclain-culver-card-20261002.webp'),
    experienceEducation:
      'McClain is a Series 7, 63, 65 and 87 licensed registered representative. He has 5 years of Wall Street Equity Research experience, analyzing public companies and market trends across multiple sectors. He began his career in Finance at Delta Air Lines, then moved into wealth management at UBS before transitioning to Equity Research. He specializes in tailored planning for non-traditional financial profiles, including equity compensation and self-employment strategies. McClain has a B.S. in Finance from Georgia Institute of Technology.',
    professionalImageUrl: getFileFromNwCDN('mcclain-culver-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/mculver-nerdwalletwealthpartners/1-1-meeting',
  },
  {
    name: 'David Muller',
    imageUrl: getFileFromNwCDN('david-muller-card-20261002.webp'),
    experienceEducation:
      'David is Series 7 and 66 licensed registered representative with 7+ years of experience in Wealth Management. He previously worked at AllianceBernstein, a private wealth firm, leading a team that managed $1.5 billion+ in client assets across 300+ relationships. David has a B.S. from Martin J. Whitman School of Management at Syracuse University.',
    professionalImageUrl: getFileFromNwCDN('david-muller-bio-20261001.webp'),
    calendlyUrl:
      'https://calendly.com/david-muller-nerdwalletwealthpartners/introduction-meeting-nerdwallet-wealth-partners',
  },
  {
    name: 'Stephen Montez',
    imageUrl: getFileFromNwCDN('stephen-montez-card-20261002.webp'),
    experienceEducation:
      'Stephen is a Series 66 and 7 licensed registered representative and CFP® candidate. He previously worked as a Financial Planner in high-net worth firms such as Merrill Lynch and Fidelity Investments. He has a B.S. in Psychology from LSU and a Certificate in Financial Planning from New York University.',
    professionalImageUrl: getFileFromNwCDN('stephen-montez-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/smontez-nerdwalletwealthpartners/30min',
  },
  {
    name: 'Karina Baldizon',
    credential: 'CFP®',
    imageUrl: getFileFromNwCDN('karina-baldizon-card-20261002.webp'),
    experienceEducation:
      'Karina is a Certified Financial Planner® with 14+ years of wealth advisory experience servicing high-net-worth and ultra-high-net-worth individuals, families, and institutions at Rockefeller Capital Management and Lazard Asset Management. She specializes in advising wealth creators, executives with concentrated stock positions, multi-generational families, education planning, and philanthropic planning. She has a B.A. in Communication and Media Studies from Hunter College.',
    professionalImageUrl: getFileFromNwCDN('karina-baldizon-bio-20261001.webp'),
    calendlyUrl: 'https://calendly.com/kbaldizon-nerdwalletwealthpartners/30min',
  },
]
